/* eslint-disable @next/next/no-img-element */

import { CarrierModel } from '@/lib/models/carrier/types';
import { SegmentModeType } from '@/types/api-types';
import { getPreferredIdentifier, isLocalEnv } from '@/utils/helpers';
import { tv } from '@/utils/styles';

export type CarrierLogoVariants = 'sm' | 'md';

export interface CarrierLogoProps {
  carrier: CarrierModel;
  mode?: SegmentModeType;
  variant?: CarrierLogoVariants;
}

export const getCarrierLogoImagePath = (mode: SegmentModeType, carrierCode: string) => {
  if (isLocalEnv()) {
    return `/logos/${carrierCode}_96.png`;
  }
  return `/api/image/logo/${mode}/${carrierCode}.png`;
};

const CarrierLogo = ({ carrier, mode = 'air', variant = 'sm' }: CarrierLogoProps) => {
  const carrierCode = getPreferredIdentifier(carrier?.identifiers)?.value || '';
  const path = getCarrierLogoImagePath(mode, carrierCode);

  const { base } = styles({ variant });

  return <img className={base()} src={path} alt={`Carrier Identifier: ${carrierCode}`} loading="lazy" />;
};

const styles = tv({
  slots: {
    base: 'block flex-shrink-0 overflow-hidden rounded-sm [&_img]:block [&_img]:h-auto [&_img]:w-full',
  },
  variants: {
    variant: {
      sm: {
        base: 'size-3.5',
      },
      md: {
        base: 'size-6',
      },
    },
  },
});

export { CarrierLogo };
